let uniqueId = 0;

export function getUniqueId(prefix = "") {
  uniqueId += 1;
  return prefix !== "" ? `${prefix}${uniqueId}` : uniqueId.toString();
}
